import {toast} from "react-toastify";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetServiceReportById,
    requestServiceReportUploadPictures,
    requestServiceReportUploadDeficiencyForm,
    requestServiceReportUploadSignOffForm,
    requestSaveServiceReport,
    unSubmitSchedule,
    removeImage
} from "api/menu/reporting/requests";

export const FETCH_SERVICE_REPORT_BY_ID_SUCCESS = "FETCH_SERVICE_REPORT_BY_ID_SUCCESS";
export const FETCH_SERVICE_REPORT_BY_ID_ERROR = "FETCH_SERVICE_REPORT_BY_ID_ERROR";
export const CLEAR_SERVICE_REPORT_BY_ID_ERROR = "CLEAR_SERVICE_REPORT_BY_ID_ERROR";
export const SERVICE_REPORT_LOADING = "SERVICE_REPORT_LOADING";
export const UPLOAD_SERVICE_REPORT_UPLOAD_PICTURE = "UPLOAD_SERVICE_REPORT_UPLOAD_PICTURE";
export const UPLOAD_SERVICE_REPORT_UPLOAD_DEFICIENCY_FORM = "UPLOAD_SERVICE_REPORT_UPLOAD_DEFICIENCY_FORM";
export const UPLOAD_SERVICE_REPORT_UPLOAD_SIGN_OFF_FORM = "UPLOAD_SERVICE_REPORT_UPLOAD_SIGN_OFF_FORM";
export const DELETE_IMAGE = "DELETE_IMAGE"
export const DELETE_IMAGE_SUCCESS = "DELETE_IMAGE_SUCCESS"

export const setLoading = (status) => ({
    type: SERVICE_REPORT_LOADING,
    payload: status
});

export const fetchServiceReportById =
    (serviceReportId, callback) => dispatch => {
        dispatch(setLoading(true));
        requestGetServiceReportById(serviceReportId)
            .then(response => {
                dispatch(setLoading(false));
                if (response.status === 204) {
                    toast("Cannot Enter Service Report. No Report layout Assigned", {
                        type: toast.TYPE.WARNING,
                    });
                    callback(false);
                } else {
                    dispatch({
                        type: FETCH_SERVICE_REPORT_BY_ID_SUCCESS,
                        payload: response.data
                    });
                    callback(true);
                }
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_SERVICE_REPORT_BY_ID_ERROR));
            });
    };

export const saveServiceReport = (submit, serviceReport, callback = false) => dispatch => {
    dispatch(setLoading(true));
    requestSaveServiceReport(serviceReport)
        .then(() => {
            dispatch(setLoading(true));
            toast(`Service report ${submit ? "submitted" : "saved"} successfully`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SERVICE_REPORT_BY_ID_ERROR));
        });
};

export const uploadServiceReportUploadPictures =
    (serviceReportId, images, callback) => dispatch => {
        dispatch(setLoading(true));
        requestServiceReportUploadPictures(serviceReportId, images)
            .then(response => {
                dispatch({
                    type: UPLOAD_SERVICE_REPORT_UPLOAD_PICTURE,
                    payload: response.data
                });
                //dispatch(fetchServiceReportById(serviceReportId, callback));
                callback();
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_SERVICE_REPORT_BY_ID_ERROR));
            });
    };

export const uploadServiceReportUploadDeficiencyForm =
    (serviceReportId, images, callback) => dispatch => {
        dispatch(setLoading(true));
        requestServiceReportUploadDeficiencyForm(serviceReportId, images)
            .then(response => {
                dispatch({
                    type: UPLOAD_SERVICE_REPORT_UPLOAD_DEFICIENCY_FORM,
                    payload: response.data
                });
                callback();
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_SERVICE_REPORT_BY_ID_ERROR));
            });
    };

export const uploadServiceReportUploadSignOffForm =
    (serviceReportId, images, callback) => dispatch => {
        dispatch(setLoading(true));
        requestServiceReportUploadSignOffForm(serviceReportId, images)
            .then(response => {
                dispatch({
                    type: UPLOAD_SERVICE_REPORT_UPLOAD_SIGN_OFF_FORM,
                    payload: response.data
                });
                callback();
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, FETCH_SERVICE_REPORT_BY_ID_ERROR));
            });
    };

export const requestUnSubmitSchedule = (serviceId, callback) => dispatch => {
    dispatch(setLoading(true));
    unSubmitSchedule(serviceId)
        .then(() => {
            toast("Schedule has been unsubmitted successfully", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
            callback(true);
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_SERVICE_REPORT_BY_ID_ERROR));
        });
};

export const clearServiceReport = () => dispatch => {
    dispatch({
        type: CLEAR_SERVICE_REPORT_BY_ID_ERROR
    });
};

export const deleteImage =
    (serviceId, image) => dispatch => {
        dispatch(setLoading(true));
        removeImage(serviceId, image)
            .then(response => {
                dispatch({
                    type: DELETE_IMAGE_SUCCESS,
                    payload: response.data
                });
            })
            .catch(error => {
                dispatch(defaultErrorHandler(error, DELETE_IMAGE));
            });
    };
